import React, { useState, useEffect } from 'react';
import { searchAvailability } from '../../lib/api';
import Analytics from '../../utils/analytics';

export default function TimePicker({ selectedServices, location, onSlotSelect }) {
    const [date, setDate] = useState('');
    const [slots, setSlots] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [matchedArtisanIds, setMatchedArtisanIds] = useState([]);

    // Initial Date: Today
    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        setDate(today);
    }, []);

    // Auto-fetch when date changes
    useEffect(() => {
        if (date && location && selectedServices.length > 0) {
            fetchSlots();
        }
    }, [date]);

    const fetchSlots = async () => {
        setLoading(true);
        setError('');
        setSlots([]);
        setSelectedSlot(null);
        setMatchedArtisanIds([]);

        try {
            const serviceIds = selectedServices.map(s => s.id);
            const resp = await searchAvailability({
                latitude: location.lat,
                longitude: location.lng,
                date: date,
                service_ids: serviceIds
            });
            setSlots(resp.available_slots || []);
            setMatchedArtisanIds(resp.matched_artisan_ids || []);
        } catch (err) {
            console.error(err);
            setError('Failed to load slots.');
        } finally {
            setLoading(false);
        }
    };

    const handleSlotClick = (slot) => {
        setSelectedSlot(slot);
        // Pass the first matched artisan ID (MVP: single artisan matching)
        onSlotSelect({ date, slot, artisanId: matchedArtisanIds[0] || null });

        // Analytics: Track scheduling selection
        Analytics.pushEcommerceEvent('add_shipping_info', { delivery_tier: 'scheduled_booking' });
    };

    return (
        <div className="wizard-step">
            <h2>Select a Time</h2>

            <div className="date-picker-container">
                <label>Date:</label>
                <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    min={new Date().toISOString().split('T')[0]}
                    className="form-input"
                />
            </div>

            {loading ? (
                <div className="slots-loading">Finding the best artisans...</div>
            ) : error ? (
                <div className="error-msg">{error}</div>
            ) : slots.length === 0 ? (
                <div className="no-slots">
                    <p>No availability for this date.</p>
                    <p className="hint">Try checking tomorrow!</p>
                </div>
            ) : (
                <div className="slots-grid">
                    {slots.map(slot => (
                        <button
                            key={slot}
                            className={`slot-btn ${selectedSlot === slot ? 'selected' : ''}`}
                            onClick={() => handleSlotClick(slot)}
                        >
                            {slot}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
